import { render } from "./StudentWithTrainingsBar.vue?vue&type=template&id=e05b53a6&scoped=true"
import script from "./StudentWithTrainingsBar.vue?vue&type=script&lang=js"
export * from "./StudentWithTrainingsBar.vue?vue&type=script&lang=js"

import "./StudentWithTrainingsBar.vue?vue&type=style&index=0&id=e05b53a6&lang=scss&scoped=true"

import exportComponent from "/home/misha/Рабочий стол/kolos-system-front-student/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e05b53a6"]])

export default __exports__